/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadSidebar: function () {
            var abacusSidebar = $("div.asidebar");
            if (abacusSidebar.length > 0) {
                abacusSidebar.find(".current-page").val("1");
                abacusSidebar.find(".view-more, .view-less").click(function (event) {
                    var target = $(event.currentTarget),
                            rootSidebar = target.closest("div.asidebar"),
                            currentPageInput = rootSidebar.find(".current-page"),
                            currentPage = parseInt(currentPageInput.val(), 10),
                            currentLang = rootSidebar.data("current-lang"),
                            apiBase = rootSidebar.data("api-base"),
                            currentId = rootSidebar.data("current-id"),
                            categoryField = rootSidebar.data("parent_category-field"),
                            categoryId = rootSidebar.data("parent_category-id"),
                            location = rootSidebar.data("location"),
                            postsPerPage = rootSidebar.data("posts-per-page"),
                            postsCount = rootSidebar.data("posts-count"),
                            categoryQuery;
                    if (categoryId) {
                        categoryQuery = "&" + categoryField + "=" + categoryId;
                    } else {
                        categoryQuery = "";
                    }

                    if (target.hasClass("view-more")) {
                        currentPage = currentPage + 1;
                    } else {
                        currentPage = currentPage - 1;
                    }
                    // Orden de los post
                    var order = "&order=desc";
                    currentPageInput.val(currentPage);
                    $.ajax({
                        url: "/" + currentLang + "/wp-json/wp/v2/" + apiBase + "/?page=" + currentPage + "&per_page=" + postsPerPage + "&exclude=" + currentId + categoryQuery + location + order
                    }).done(function (data) {
                        rootSidebar.find("ul.latest-posts li:visible").remove();
                        data.forEach(function (entry) {
                            var date = new Date(entry.date);
                            var day = date.getDate();
                            if (String(day).length < 2)
                                day = '0' + day;
                            var month = date.getMonth() + 1;
                            if (String(month).length < 2)
                                month = '0' + month;
                            var element = rootSidebar.find("li.template").clone();
                            var excerpt = entry.excerpt.rendered,
                                words = excerpt.split(' ');
                            var mediaURL;
                            if (entry._links && entry._links["wp:featuredmedia"]) {
                                mediaURL = entry._links["wp:featuredmedia"][0].href.replace("/wp-json/wp/", "/es/wp-json/wp/");
                            }
                            var rating = entry.meta._kksr_avg;
                            if(!rating) {
                                rating = "0";
                            }

                            if(words.length > 15) {
                                excerpt = words.slice(0,15).join(' ') + '&hellip;';
                            }
                            $(element).removeClass("template");
                            $(element).addClass("post-" + entry.id);
                            $(element).addClass("post");
                            $(element).find("span.date").html(day + '/' + month + '/' + date.getFullYear().toString());
                            $(element).find("span.loc").html((entry.location || {}).post_title);
                            $(element).find("h3.menu-title a").html(entry.title.rendered);
                            $(element).find("h3.menu-title a").attr("href", entry.link);
                            $(element).find(".counters-row a").attr("href", entry.link);
                            $(element).find("p.noreadmore").html(excerpt.replace("<p>", "").replace("</p>", ""));
                            if (entry.show_category && entry.category_label) {
                                $(element).find("p.cat").html(entry.show_category + "<span class='label " + entry.category_label + "'></span>");
                            }

                            UTIL.findShares(element);
                            rootSidebar.find("ul.latest-posts").append(element);
                            $(element).find(".rating-container .rating").html(rating);
                            $(element).show();
                            if (mediaURL) {
                                $.getJSON(mediaURL, function (data) {
                                    rootSidebar.find(".post-" + entry.id + " .attachment-full").attr('src', data.media_details.sizes.full.source_url);
                                });
                            } else {
                                rootSidebar.find(".post-" + entry.id + " .attachment-full").hide();
                            }
                        });
                        if (currentPage * postsPerPage >= postsCount) {
                            rootSidebar.find(".view-more").hide();
                        } else {
                            rootSidebar.find(".view-more").show();
                        }
                        if (currentPage == 1) {
                            rootSidebar.find(".view-less").hide();
                        } else {
                            rootSidebar.find(".view-less").show();
                        }
                        $('html,body').scrollTop(0);
                    });
                });
            }
        },
        loadShopsPaginator: function () {
            var currentPage = 1;
            function showPage(page) {
                var perPage = 3,
                        startIndex = perPage * (page - 1),
                        endIndex = startIndex + perPage,
                        entries = $("#wpsl-stores ul li");
                entries.slice(startIndex, endIndex).show();
                if (currentPage === 1) {
                    $(".shop-previous").hide();
                } else {
                    $(".shop-previous").show();
                }
                if (currentPage === Math.floor(entries.length / perPage)) {
                    $(".shop-next").hide();
                } else {
                    $(".shop-next").show();
                }
            }
            $(".shop-next").click(function (e) {
                e.preventDefault();
                currentPage += 1;
                showPage(currentPage);
            });
            $("#wpsl-stores").on("click", ".wpsl-directions", function () {
                $(".shop-next").hide();
            });
            $("#wpsl-result-list").on("click", "#wpsl-direction-start", function () {
                $(".shop-next").show();
            });
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');

            function showNavEntry(entry) {
                jQuery("nav.nav-layer").removeClass('show');
                jQuery(".banner .container .nav-layer").removeClass('show');
                jQuery(entry).addClass('show');
            }
            function hideNavEntry(entry) {
                jQuery(entry).removeClass('show');
            }
            function setCurrent(entry) {
                jQuery('.menu-item').removeClass('current');
                jQuery(entry).addClass('current');
            }
            jQuery('.button-quienes-somos').mouseover(function () {
                showNavEntry('#nav-quienes-somos');
                setCurrent('.button-quienes-somos');
            });
            jQuery('.button-comunidades').mouseover(function () {
                showNavEntry('#nav-comunidades');
                setCurrent('.button-comunidades');
            });
            jQuery('#nav-quienes-somos').mouseleave(function () {
                hideNavEntry("#nav-quienes-somos");
                jQuery('.menu-item').removeClass('current');
            });
            jQuery('#nav-comunidades').mouseleave(function () {
                hideNavEntry("#nav-comunidades");
                jQuery('.menu-item').removeClass('current');
            });
            jQuery('#button-close-quienes-somos').click(function () {
                hideNavEntry("#nav-quienes-somos");
                jQuery('.menu-item').removeClass('current');
            });
            jQuery('#button-close-comunidades').click(function () {
                hideNavEntry("#nav-comunidades");
                jQuery('.menu-item').removeClass('current');
            });
            //smoothscroll

            // Select all links with hashes
            jQuery('a[href*="#"]')
                    // Remove links that don't actually link to anything
                    .not('[href="#"]')
                    .not('[href="#0"]')
                    .click(function (event) {
                        // On-page links
                        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                                location.hostname == this.hostname) {
                            // Figure out element to scroll to
                            var target = jQuery(this.hash);
                            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
                            // Does a scroll target exist?
                            if (target.length) {
                                // Only prevent default if animation is actually gonna happen
                                event.preventDefault();
                                jQuery('html, body').animate({
                                    scrollTop: target.offset().top
                                }, 1000, function () {
                                    // Callback after animation
                                    // Must change focus!
                                    var $target = jQuery(target);
                                    $target.focus();
                                    if ($target.is(":focus")) { // Checking if the target was focused
                                        return false;
                                    } else {
                                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                                        $target.focus(); // Set focus again
                                    }
                                });
                            }
                        }
                    });
        },
        loadRatings: function () {
            var locale = document.location.pathname.split("/")[1],
                title;
            switch(locale) {
                case "es":
                    title = "VALORA ESTE ARTÍCULO";
                    break;
                case "ca":
                    title = "VALORA AQUEST ARTICLE";
                    break;
                default:
                    title = "VALORA AQUEST ARTICLE";
                    break;
            }
            jQuery( ".kk-star-ratings" ).before( '<h3 class="rate-title">' + title + '</h3>' );
            // jQuery("div[itemprop=aggregateRating]").remove();
        },
        findShares: function(entryItem) {
            var entry = jQuery(entryItem),
                url = entry.find('a')[0].href;
            jQuery.getJSON('https://api-public.addthis.com/url/shares.json?url=' + url + '&callback=?', function(addthis) {
                entry.find('.shares').html(addthis.shares);
            });
        },
        loadShares: function() {
            jQuery('ul.latest-posts li.post, .list-comunities .list-comunities-item').each(function(_index, entryItem) {
                UTIL.findShares(entryItem);
            });
        },
    };

    //accordion
    var allPanels = $('.accordion .content').hide();

    $('.accordion h2 a').click(function () {
        allPanels.slideUp();
        $(this).parent().next().slideDown();
        return false;
    });

    // Load Events
    $(document).ready(UTIL.loadEvents);
    // Load sidebar
    $(document).ready(UTIL.loadSidebar);
    // Load shops paginator
    $(document).ready(UTIL.loadShopsPaginator);
    // Load ratings code
    $(document).ready(UTIL.loadRatings);
    $(document).ready(UTIL.loadShares);


})(jQuery); // Fully reference jQuery after this point.
